<template>
  <UsersShowAdmin
          v-if="$store.getters.getIsAdminRights === 'admin'"
          :UEAdmin="UEAdmin"
          :orderFees="orderFees"
          :orderFBAFees="orderFBAFees"
          :shipStation="shipStation"
          :isAdminType="isAdminType"
          @changeUser="changeUser"
          @reload="reload"
  />
</template>

<script>
  import UsersShowAdmin from "./UsersShowAdmin/UsersShowAdmin";
  import {UserEdit} from "../../models/UserEdit";
  import {userAvatarMixin} from "../../../../../mixins/usersMixins/userAvatarMixin";

  export default {
    name: "UsersShow",

    components: {
      UsersShowAdmin,
    },

    mixins: [userAvatarMixin],

    watch: {

    },

    computed: {
      isAdminType() {
        return this.$route.query.adminType === 'true'
      }
    },

    data() {
      return {
        UEAdmin: new UserEdit(),

        orderFees: [],
        orderFBAFees: [],
        shipStation: [],
      }
    },

    mounted() {

      let userId = this.$route.params.id
      if(userId){
        this.UEAdmin.data.user.setUserId(userId)

        this.getDataUserManage(userId)

        this.getFeeOrderFBMForPresets()

        this.getFeeOrderFBAForPresets()

        this.getFeeShipStationFBMForPresets()
      }

    },

    methods: {

      reload() {
        this.getDataUserManage(this.UEAdmin.data.user.getUserId())
      },

      getDataUserManage(id){
        this.$store.dispatch('getUserManageItem', id).then(response => {
          let responseData = this.getRespData(response)
          let user = responseData.user
          let userData = user.user_setting

          this.UEAdmin.setHistoryOfChanged(user.activityUUID)

          this.UEAdmin.data.user.setUser(user)
          this.UEAdmin.data.userAccess.setUserAccessItem(userData, user)
          this.UEAdmin.data.userPresets.setUserPresetsItem(user, this)
          this.UEAdmin.data.userDelivery.setUserDeliveryItem(userData)
          this.UEAdmin.data.userDocuments.setItem(userData)

          this.setUserAvatar(this.UEAdmin.data.user)
        }).catch(error => this.createErrorLog(error))
      },

      getFeeOrderFBMForPresets(){
        this.$store.dispatch('getFeeOrderFBM').then(response => {
          this.orderFees = this.getRespPaginateData(response)
        })
      },
      getFeeOrderFBAForPresets(){
        this.$store.dispatch('getFeeOrderFBA').then(response => {
          this.orderFBAFees = this.getRespPaginateData(response)
        })
      },

      getFeeShipStationFBMForPresets(){
        this.$store.dispatch('getFeeShipStationFBM').then(response => {
          this.shipStation = this.getRespPaginateData(response)
        })
      },

      async uploadFiles(files) {
        for (const item of files) {
          let type = this.isAdmin ? 'adminUploadUserDocument' : 'uploadUserDocument'

          await this.$store.dispatch(type, {id: this.$route.params.id, data: item}).then((response) => {

            switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
                let userDocumentsFiles = this.UEAdmin.data.userDocuments.data.Files
                let newFile = this.getRespData(response)?.smallImageEntity || this.getRespData(response)?.pdf

                if(newFile?.extension !== 'pdf') {
                  newFile.typeBase64 = `image`
                  newFile.base64 = `data:application/${item.extension};base64,` + newFile?.file
                }

                userDocumentsFiles.setDownloadFiles([...userDocumentsFiles.getDownloadFiles(), newFile])
                userDocumentsFiles.data.files.pop()
                break
              }
              /**
               * Validation Error
               */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                let errors = response.response.data.errors;
                this.notifyErrorHelper(errors)
                break
              }
              /**
               * Undefined Error
               */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }
          })
        }
      },

      sendDocumentsFiles() {
        let files = this.UEAdmin.data.userDocuments.prepareSave()

        return this.uploadFiles(files)
      },


      changeUser() {
        let UEAdminData = this.UEAdmin.data

        if(!UEAdminData.userPresets.userPresetsValidate()) return
        if(!UEAdminData.userDocuments.userDocumentsValidate()) return

        let commission = this._.has(UEAdminData.userPresets.getWarehouseCommission(), 'value') ?
            parseInt(UEAdminData.userPresets.getWarehouseCommission().value) : -1

        let data = {
          user_id: this.$route.params.id,
          user: {
            "commission" : commission,
            "fulfilment_by_amazon" :
              parseInt(UEAdminData.userAccess.getUserAccessFullfilment().fulfilment_by_amazon),
            "fulfilment_by_merchant" :
              parseInt(UEAdminData.userAccess.getUserAccessFullfilment().fulfilment_by_merchant),
            'locked': UEAdminData.userAccess.getBlockUser()
          },
          'shipper_data': UEAdminData.userDelivery.getPrepareUserDeliveryItem(),
          'user_presets': UEAdminData.userPresets.getPrepareUserPresetsItem(),
          'balance_output': UEAdminData.userAccess.getUserAccessItem(),
          'userSettings': UEAdminData.userAccess.getUserUserSettings(),
          'payment': UEAdminData.userAccess.getUserPayment(),
          'fulfilment': {use_merchant: false}
        }

        data['user_presets']['n_mark'] = UEAdminData.userAccess.getStatusNewUser()
        data['user_presets']['documents_checked'] = UEAdminData.userDocuments.getMark()

        if(UEAdminData.userPresets.getOrderFeeForManyProducts()?.id) {
          data['userSettings']['user_order_item_fee_id'] = UEAdminData.userPresets.getOrderFeeForManyProducts().id
        } else {
          data['userSettings']['user_order_item_fee_id'] = null
        }

        if(this.isAdminType) {
          data = {
            user_id: data['user_id'],
            user: {
              locked: data['user']['locked'],
            }
          }
        }

        this.$store.dispatch('changeUserManage', data).then(async response => {

          if (!this.getResponseStatus(response)) return this.openNotify('error', 'common_notificationUndefinedError')

          switch (this.getResponseStatus(response)) {
            /**
             * Success
             */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.openNotify('success', 'common_notificationRecordChanged')

              if(UEAdminData.userDocuments.data.Files.getFiles().length > 0){
                await this.sendDocumentsFiles()
              }

              this.reload()
              break
            }
            /**
             * Validation Error
             */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
            /**
             * Undefined Error
             */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }

        })
      },

    },


  }
</script>

<style scoped>

</style>
